// extracted by mini-css-extract-plugin
export var breakLink = "pagination-module--breakLink--676a4";
export var paginationActivePage = "pagination-module--paginationActivePage--55495";
export var paginationActivePageSmall = "pagination-module--paginationActivePageSmall--f48b9";
export var paginationDisabled = "pagination-module--paginationDisabled--e2094";
export var paginationLink = "pagination-module--paginationLink--95ecc";
export var paginationLinkSmall = "pagination-module--paginationLinkSmall--03087";